import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { Tooltip } from '@mui/material';
import Paper from '@mui/material/Paper';
import { KeyboardArrowDown, KeyboardArrowUp, Delete, Check, Edit } from '@mui/icons-material';
import Paginating from '../Paginating';
import api from '../../services/Api';
import { useState, useEffect } from 'react';
import Loading from '../Loading';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import { FaEye } from 'react-icons/fa';
import MyDialog from '../../utils/MyDeleteDialog';
import { getValidationClassName } from '../../utils/validationUtils';
import { getDeleteButtonClassName } from '../../utils/deleteUtils';
import { handleValidation } from '../../utils/handleValidate';
import MyAlert from '../../utils/MyAlert';
import { useNavigate } from 'react-router-dom';


function Row(props) {

  const navigate = useNavigate();

  const user = useAuthUser()
  const auth = useAuthHeader()

  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [openValidationAlert, setOpenValidationAlert] = React.useState(false);
  const [validated, setValidated] = useState(false);

  const handleDeleteClick = () => {
    setOpenDeleteDialog(true);
  };

  const handleEditClick = () => {
    navigate(`/works/edit`, { state: { work: row } });
  };

  const handleValidationClick = async () => {
    try {
      const validationSuccessful = await handleValidation(row, user, auth, 'work');
      if (validationSuccessful) {
        setValidated(true);
        setOpenValidationAlert(true);
      }else{
        setValidated(false)
        setOpenValidationAlert(true);
      }
    } catch (error) {
    } finally {
    }
  };

  const [display, setDisplay] = useState()

  useEffect(() => {
    validated ? setDisplay("d-none") : setDisplay()
  }, [validated])

  return (
    <React.Fragment>
      {openValidationAlert && (
          <MyAlert
            showAlert={true}
            handleCloseAlert={() => setOpenValidationAlert(false)}
            severity= { validated ? "success" : "error"}
            heading={ validated ? "Validação efectuada com sucesso!" : "Erro ao Validar!"}
            message={ validated ? "Artigo validado com sucesso!" : "Trabalho não Validado"}
            autoDismissTime={3000}
          />
        )}
      <div>
        <MyDialog row={row} open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)} url={'work'} title={'Trabalho'} />
      </div>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} >
        <TableCell >
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp  /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.title}
        </TableCell>
        <TableCell>
          {
            <p>{row.student.last_name} - <strong> <small> {row.student.name}</small> </strong> </p>
          }
        </TableCell>
        <TableCell>{row.area}</TableCell>
        <TableCell>{row.date_presented}</TableCell>
        <TableCell>{(row.validation && row.validation2) ? "Validado" : ((row.validation && !row.validation2) || (!row.validation && row.validation2)) ? "1/2" : "0/2" }</TableCell>
        <TableCell align='right'>
          <div>
            <Tooltip title="Validar " arrow 
              className={ display ? display : getValidationClassName(user, row) } 
              onClick={() => handleValidationClick(row, user, auth)}>
              <IconButton
                aria-expanded="false"
                size="small"
              >
              <Check style={{ color: "green" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Ver Detalhes" arrow onClick={ () => setOpen(!open)}>
              <IconButton
                aria-expanded="false"
                size="small"
              >
              <FaEye style={{ color: "green" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar" arrow>
              <IconButton
                aria-expanded="false"
                size="small"
                onClick={handleEditClick}
              >
              <Edit style={{ color: "green" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Apagar Projecto" arrow
              className={display ? display : getDeleteButtonClassName(user(), row)}>
              <IconButton
                aria-expanded="false"
                size="small"
                onClick={handleDeleteClick}
              >
              <Delete style={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          </div>
        </TableCell>
      </TableRow>
      <TableRow className="bg-light">
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft:70 }} colSpan={9}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Detalhes
              </Typography>
              <Typography gutterBottom component="div">
                <strong> <small>  Autor </small> </strong>
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow style={{ backgroundColor: 'InfoBackground' }}>
                    <TableCell/>
                    <TableCell>Nome</TableCell>
                    <TableCell>Apelido</TableCell>
                    <TableCell>Numero Estudante</TableCell>
                    <TableCell>E-mail</TableCell>
                    <TableCell>Curso</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                      <TableCell/>
                      <TableCell >
                        {row.student.name}
                      </TableCell>
                      <TableCell>{row.student.last_name}</TableCell>
                      <TableCell>{row.student.number}</TableCell>
                      <TableCell>{row.student.email}</TableCell>
                      <TableCell>{row.student.course.name}</TableCell>
                    </TableRow>
                </TableBody>
              </Table>
              <Typography gutterBottom component="div">
                <strong> <small>  Supervisor(es) </small> </strong>
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow style={{ backgroundColor: 'InfoBackground'}}>
                    <TableCell/>
                    <TableCell>Nome</TableCell>
                    <TableCell>Apelido</TableCell>
                    <TableCell>Envolvimento</TableCell>
                    <TableCell>E-mail</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Nível Académico</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.supervisors?.map((supervisor, index) => (
                    <TableRow key={index}>
                      <TableCell/>
                      <TableCell >
                        {supervisor.name}
                      </TableCell>
                      <TableCell>{supervisor.last_name}</TableCell>
                      <TableCell>{supervisor.pivot.involvement}</TableCell>
                      <TableCell>{supervisor.email}</TableCell>
                      <TableCell>{supervisor.type}</TableCell>
                      <TableCell>{supervisor.academic_level}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}


export default function CollapsibleTable({searchKey}) {

  const auth = useAuthHeader()

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const getData = async (page) => {
    
    const res = await api.get(`works?page=${page}`,
    {
      headers: {
        Authorization: auth()
      }
    },
    {
      withCredentials: true
    })
    setData(res.data.works)
    setTotalPages(res.data.works.last_page)
    setLoading(false)
  }

  const getSearchData = async (searchKey, page) => {
    
    const res = await api.get(`works/${searchKey}?page=${page}`,
    {
      headers: {
        Authorization: auth()
      }
    },
    {
      withCredentials: true
    })
    setData(res.data.works)
    setTotalPages(res.data.works.last_page)
    setLoading(false)
  }

  useEffect(() => {
    setLoading(true)
    if (searchKey !== '') {
      getSearchData(searchKey, currentPage)
    }else
      getData(currentPage);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, searchKey])


  return (
    <>
      { loading ? (
        <Loading/>
      ) : (
        <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead className='bg-success'>
            <TableRow>
              <TableCell/>
              <TableCell className='text-light'><strong>Título</strong></TableCell>
              <TableCell className='text-light'><strong>Autor</strong></TableCell>
              <TableCell className='text-light'><strong>Área</strong></TableCell>
              <TableCell className='text-light'><strong>Data de Apresentação</strong></TableCell>
              <TableCell className='text-light'><strong>Validações</strong></TableCell>
              <TableCell align="right" className='text-light'><strong>Acções</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              data?.data?.map((item, index) => (
                <Row key={index} row={item} data={[item]}/>
              ))
            }
          </TableBody>
        </Table>
        <Paginating currentPage={currentPage} total={totalPages} onPageChange={(page) => setCurrentPage(page)}/>
      </TableContainer>
      )}
  </> 
  );
}